export default __webpack_public_path__ + "static/media/membership.dccf7924.png";